import InitFacebookSdk from '../../util/InitFacebookSdk';

type ShareProps = {
  method?: string;
  href?: string;
  display?: string;
};

/**
 * Share to facebook lib.
 */
export const shareOnFacebook = ({
  display = 'popup',
  method = 'share',
  href = window.location.href,
}: ShareProps = {}) => {
  InitFacebookSdk(() => {
    FB.ui({
      display,
      method,
      href,
    });
  });
};
